/* eslint-disable no-restricted-syntax */
export default {
  getEnum(embeddedRoleEnumeration) {
    const enumList = Object.keys(embeddedRoleEnumeration);
    const newRolesEnum = [];
    for (let i = 0; i < enumList.length; i += 1) {
      newRolesEnum.push({
        text: embeddedRoleEnumeration[enumList[i]],
        value: enumList[i],
      });
    }
    return newRolesEnum;
  },
  setEnums(store, enums) {
    store.commit('setEnums', {
      status: {
        tranche: enums.tranche,
        trancheUpdate: enums.trancheUpdate,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/EnumerationService.js